import React, { Component } from 'react';
import styles from './loading.scss';

class LoadingIndicator extends Component {
  render() {
    return (
      <div className={styles.loader}>
        <div className={styles.circle1}></div>
        <div className={styles.circle2}></div>
        <div className={styles.circle3}></div>
        <div className={styles.circle4}></div>
      </div>
    );
  }
}

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/layout/indicators/loading.jsx